<template>
    <div class="public_container department_add_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container" v-loading="loading">
            <van-form
                ref="customForm"
                :rules="customFormRules"
                error-message-align="right"
                input-align="right"
                label-width="10em"
                :show-error-message="false"
                scroll-to-error
            >
                <van-field
                    required
                    v-model="formData.department"
                    name="department"
                    label="部门名称"
                    placeholder="请输入"
                    maxlength="10"
                    :rules="[{ required: true, message: '请输入' }]"
                >
                </van-field>
                <van-field
                    v-model="formData.didText"
                    name="didText"
                    label="上级部门"
                    placeholder="请选择"
                    @click="handleClickSelectDepartment"
                    :disabled="!this.formData.did || this.formData.pid == 0"
                    readonly
                >
                </van-field>
                <van-field
                    v-model="formData.directorText"
                    name="directorText"
                    label="部门负责人"
                    placeholder="请选择"
                    is-link
                    readonly
                    @click="handleClickSelect"
                >
                </van-field>
            </van-form>
        </div>
        <!-- 人员选择 -->
        <UserSearchSelect
            :userSelectVisible.sync="userSelectVisible"
            :userSelectTitle="'选择人员'"
            :selectType="'one'"
            :selectedUser="formData.director"
            @selectUserData="handleSelectUserData"
            v-if="userSelectVisible"
        />

        <DepartmentSelect
            :departmentSelectVisible.sync="departmentSelectVisible"
            @success="handleSelectDeparemtData"
            v-if="departmentSelectVisible"
        />
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
    </div>
</template>

<script>
import { DepartmentAdd } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
import DepartmentSelect from "@/components/mComponents/DepartmentSelect.vue";
export default {
    name: "MDepartmentAdd",
    components: { ReturnNavBar, UserSearchSelect, DepartmentSelect },
    data() {
        return {
            pid: "",
            pName: "",
            loading: false,
            btnDisabled: false,
            formData: {
                pid: "", // 上级部门
                department: "",
                did: "",
                didText: "",
                director: [],
                directorText: "",
            },
            customFormRules: {},
            userSelectVisible: false,
            departmentSelectVisible: false,
        };
    },
    created() {
        if (this.$route.query) {
            this.formData.did = this.$route.query.did;
            this.formData.didText = this.$route.query.pName;
            this.formData.pid = this.$route.query.pid
        }
    },
    methods: {
        handleClickSelect() {
            this.userSelectVisible = true;
        },
        handleSelectUserData(data) {
            let new_data = data ? [data] : [];
            this.formData.director = new_data.map((map) => {
                return map.uid;
            });
            this.formData.directorText = new_data
                .map((map) => {
                    return map.name;
                })
                .join(",");
        },
        handleClickSelectDepartment() {
            if (this.formData.did && this.formData.pid != 0) {
                this.departmentSelectVisible = true;
            }
        },
        // 选择部门成功回调
        handleSelectDeparemtData(data) {
            this.formData.did = data.relate_id;
            this.formData.didText = data.relate_name;
        },
        handleClickConfirm() {
            this.$refs.customForm.validate().then(() => {
                let postData = {
                    department_name: this.formData.department,
                    pid: this.formData.did || 0,
                    department_heads: this.formData.director,
                };
                this.btnDisabled = true;
                DepartmentAdd(postData).then((res) => {
                    if (res.code === 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.$router.go(-1);
                                this.btnDisabled = false;
                            },
                        });
                    } else {
                        this.btnDisabled = false;
                        this.$toast(res.message);
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.department_add_wrap {
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
</style>
